function setElementsInblog() {
    const article = document.querySelector('.article-template__content');
    if (!article) return;
    console.log(article);

    const popupLocation = document.querySelector('#ebook-in-blog');
    const relatedCollectionLocation = document.querySelector('#products-in-blog');

    const popupElement = document.querySelector('.article-template__popup-inner');
    const relatedCollectionElement = document.querySelector('.article-template__related_collection-inner');

    if (popupLocation && popupElement) {
        popupLocation.innerHTML = popupElement.innerHTML;
        popupElement.remove();
    }

    if (relatedCollectionLocation && relatedCollectionElement) {
        relatedCollectionLocation.innerHTML = relatedCollectionElement.innerHTML;
        relatedCollectionElement.remove();
    }
}

setElementsInblog();